import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=6f768282"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=6f768282&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f768282')) {
      api.createRecord('6f768282', component.options)
    } else {
      api.reload('6f768282', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=6f768282", function () {
      api.rerender('6f768282', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/Components/Sidebar.vue"
export default component.exports